import { useState, createContext } from "react";

export const mobileMenuContext = createContext();

const MobileMenuProvider = (prop) => {
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <mobileMenuContext.Provider value={{ openMenu, setOpenMenu }}>
      {prop.children}
    </mobileMenuContext.Provider>
  );
};
export default MobileMenuProvider;
